import { IoIosArrowForward } from "react-icons/io"
import { BoxLink, BoxPlace, BoxUrl } from "./styles"

interface IProps {
  title: string
}

export const ReturnArea = ({ title }: IProps) => {
  return (
    <BoxUrl>
      <BoxLink to="../configuracoes">Configurações</BoxLink>

      <IoIosArrowForward fontSize="1.125rem" />
      <BoxPlace>{title}</BoxPlace>
    </BoxUrl>
  )
}
